(function() {
  var utilityBar = document.querySelector('.utility-bar');
  var sliderButtons = document.querySelector('.announcement-bar-slider');
  var slider = document.querySelector('[id^="Slider-"]');
  if (!utilityBar || !slider || !sliderButtons) return;

  function syncColor() {
    var activeSlide = slider.querySelector('.slider__slide:not([aria-hidden="true"])');
    if (!activeSlide) activeSlide = slider.querySelector('.slider__slide');
    if (!activeSlide) return;

    var styles = getComputedStyle(activeSlide);
    var bg = styles.getPropertyValue('--color-background').trim();
    var fg = styles.getPropertyValue('--color-foreground').trim();

    if (bg) utilityBar.style.setProperty('background-color', 'rgb(' + bg + ')', 'important');
    if (fg) {
      sliderButtons.style.setProperty('color', 'rgb(' + fg + ')', 'important');
      sliderButtons.querySelectorAll('svg').forEach(function(svg) {
        svg.style.setProperty('fill', 'rgb(' + fg + ')', 'important');
        svg.style.setProperty('color', 'rgb(' + fg + ')', 'important');
      });
    }
  }

  syncColor();

  var observer = new MutationObserver(syncColor);
  observer.observe(slider, { attributes: true, subtree: true, attributeFilter: ['aria-hidden'] });
})();
